"use client";
import { DefaultLiveVideoSkin } from "../../internal/skins/default-live-video/skin.js";
import { jsx } from "react/jsx-runtime";
//#region src/presets/live-video/skin.tsx
function LiveVideoSkin(props) {
	return /* @__PURE__ */ jsx(DefaultLiveVideoSkin, { ...props });
}
//#endregion
export { LiveVideoSkin };

//# sourceMappingURL=skin.js.map